import { Tooltip, Typography, useTheme } from '@mui/material';

interface ErrorMessageProps {
  message?: string | null;
  absolute?: boolean;
}

function ErrorMessage({ message, absolute = true }: ErrorMessageProps) {
  const theme = useTheme();

  return (
    <Tooltip
      title={message ?? ''}
      disableHoverListener={!message}
      placement="bottom-start"
    >
      <Typography
        sx={{
          color: theme.palette.error.main,
          fontSize: '10px',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          ...(absolute === true
            ? { position: 'absolute', top: '100%', mt: '2px' }
            : { mt: 1 }),
        }}
      >
        {message}
      </Typography>
    </Tooltip>
  );
}

export default ErrorMessage;
